import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = (): null => {
	const location = useLocation();

	useEffect(() => {
		if ('scrollRestoration' in window.history) {
			window.history.scrollRestoration = 'manual';
		}
	}, []);

	useLayoutEffect(() => {
		const scrollToTop = (): void => {
			window.scrollTo(0, 0);
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0;

			const container = document.querySelector<HTMLElement>('main, .content, .layout, .app-wrapper');
			container?.scrollTo(0, 0);
		};

		scrollToTop();
		requestAnimationFrame(scrollToTop);
		const t1 = setTimeout(scrollToTop, 100);
		const t2 = setTimeout(scrollToTop, 300);

		return (): void => {
			clearTimeout(t1);
			clearTimeout(t2);
		};
	}, [location.key]);

	return null;
};
